import { IconicPencil } from '@insify/design-system/iconic-icons';
import { Map } from '@insify/map-component';
import { useTranslation } from 'react-i18next';

import { useProfile } from '../../../api/queries/useProfile';
import { InfoDisplay } from '../../InfoDisplay';
import { Tabs } from '../../Tabs';
import { TypeformButton } from '../../TypeformButton/TypeformButton';
import styles from '../styles.module.css';

import type { Bundle } from '../../../types/Policy';

const accessMapKey = window.insify_runtime_config.MAPBOX_ACCESS_TOKEN;

interface Props {
  bundle: Bundle;
}
export const ProductAddressTab: React.FC<Props> = ({ bundle }) => {
  const { t } = useTranslation('policy');
  const { data: profile } = useProfile();

  const address =
    bundle.address &&
    `${bundle.address?.street} ${bundle.address?.houseNumber}, ${bundle.address?.city}, ${bundle.address?.postalCode}`;

  return (
    <Tabs.Panel id='address'>
      <Map
        className={styles.map}
        accessToken={accessMapKey}
        // TODO: we're not receiving coordinates from the API. check if this is available
        // coordinates={{ latitude: '52.36850344823484', longitude: '4.905856902578698' }}
      />
      <h2>{t(bundle.type === 'company' ? 'address.company_title' : 'address.personal_title')}</h2>
      <p>{t('address.subtitle')}</p>
      <InfoDisplay.Container>
        <InfoDisplay.Label>{t('address.label')}</InfoDisplay.Label>
        <InfoDisplay.Text data-hj-suppress>{address}</InfoDisplay.Text>
      </InfoDisplay.Container>

      <TypeformButton
        type='button'
        trackingId='editAddress'
        formType='change_form'
        policyType={bundle.type}
        kind='neutral'
        label={t('edit')}
        hiddenFields={{
          email: profile?.result?.personalInformation.email,
          policy_number: bundle.coverages[0].policyNumber,
          country: bundle.country,
          name: bundle.type === 'company' ? bundle.companyName : profile?.result?.personalInformation.name,
          change_type: bundle.type === 'company' ? 'company_address' : 'personal_address',
        }}
        confirmation={t('change_confirmation')}
        leftIcon={<IconicPencil />}
        className={styles.editButton}
      />
    </Tabs.Panel>
  );
};
